// Arabic portal-stream strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enPortal } from './en-portal.ts';
import type { Message } from './types.ts';

export const arPortal: { readonly [K in keyof typeof enPortal]: Message } = {
  'portal.v.printerUnknown': 'اختر طابعة طرفية مسموحًا بها في موقع هذا الكشك.',
  'portal.api.printRetryLimit': 'حاول الكشك طباعة هذه البطاقة مرتين. يُرجى استلام بطاقتك من الاستقبال.',
  'portal.api.printNotRetryable': 'لا يمكن طباعة هذه البطاقة مرة أخرى هنا. يُرجى السؤال في الاستقبال.',
  'portal.api.printerUnavailable': 'طابعة البطاقات غير متاحة. يُرجى استلام بطاقتك من الاستقبال.',

  'portal.receipt.title': 'إيصالك',
  'portal.receipt.notice': 'الإشعار',
  'portal.receipt.version': '{title}، الإصدار {number}',
  'portal.receipt.decision': 'قرارك',
  'portal.receipt.decision.accepted': 'تم القبول',
  'portal.receipt.decision.signed': 'تم التوقيع بالاسم المكتوب',
  'portal.receipt.decision.declined': 'تم الرفض',
  'portal.receipt.signedName': 'الاسم المكتوب كتوقيع',
  'portal.receipt.time': 'وقت التسجيل',
  'portal.receipt.where': 'المكان',
  'portal.receipt.channel.portal': 'بطاقة الزائر',
  'portal.receipt.channel.kiosk': 'كشك الخدمة الذاتية',
  'portal.receipt.channel.reception': 'الاستقبال',
  'portal.receipt.digest': 'رمز الإيصال',
  'portal.receipt.digestShow': 'عرض الرمز كاملًا',
  'portal.receipt.digestHint': 'هذا الرمز بصمة SHA-256 لنص الإشعار الذي رأيته وقرارك والاسم الذي كتبته والوقت. احتفظ به إذا أردت الرجوع إلى هذا القرار لاحقًا.',
  'portal.receipt.legal': 'يسجّل هذا الإيصال قرارك. وهو ليس بيانًا عن الأثر القانوني للإشعار.',
  'portal.receipt.declinedNote': 'يُسجَّل الرفض رفضًا، ولا يُعدّ موافقة أبدًا.',
  'portal.receipt.notCurrent': 'نُشر إصدار أحدث من هذا الإشعار بعد هذا القرار.',
  'portal.receipt.uaePassSigned': 'وُقّع أيضًا عبر الهوية الرقمية (UAE PASS) في {when}.',
  'portal.receipt.uaePassArtifact': 'رمز المستند الموقّع',

  'portal.sign.title': 'التوقيع عبر الهوية الرقمية (اختياري)',
  'portal.sign.intro': 'يمكنك أيضًا توقيع هذا السجل عبر الهوية الرقمية (UAE PASS). توقيعك بالاسم المكتوب مسجّل بالفعل؛ هذه الخطوة اختيارية ولا تغيّر زيارتك.',
  'portal.sign.scope': 'الإذن المطلوب من الهوية الرقمية',
  'portal.sign.document': 'رمز السجل المراد توقيعه',
  'portal.sign.consent': 'أوافق على تحويلي إلى الهوية الرقمية لتوقيع هذا السجل. يتلقى Passage نتيجة التوقيع فقط، ولا يتلقى كلمة مرور الهوية الرقمية أبدًا.',
  'portal.sign.start': 'التوقيع عبر الهوية الرقمية',
  'portal.sign.starting': 'جارٍ فتح الهوية الرقمية…',
  'portal.sign.errorHint': 'توقيعك بالاسم المكتوب ما زال مسجّلًا، ولا يلزم شيء آخر لزيارتك.',
  'portal.sign.providerUnavailable': 'التوقيع عبر الهوية الرقمية غير متاح حاليًا. توقيعك بالاسم المكتوب مسجّل ولا يلزم شيء آخر.',
  'portal.sign.last.started': 'هناك طلب توقيع مفتوح في الهوية الرقمية. إذا أغلقته، يمكنك البدء من جديد.',
  'portal.sign.last.cancelled': 'رفضت التوقيع في الهوية الرقمية. يبقى توقيعك بالاسم المكتوب مسجّلًا، ويمكنك المحاولة مرة أخرى.',
  'portal.sign.last.failed': 'لم يكتمل التوقيع عبر الهوية الرقمية. يبقى توقيعك بالاسم المكتوب مسجّلًا، ويمكنك المحاولة مرة أخرى.',
  'portal.sign.last.unknown': 'لم تُجب الهوية الرقمية في الوقت المحدد، لذلك لا يظهر السجل موقّعًا. يمكنك المحاولة مرة أخرى.',
  'portal.sign.last.expired': 'انتهت صلاحية طلب التوقيع. يمكنك البدء من جديد.',

  'portal.ret.signTitle': 'التوقيع عبر الهوية الرقمية',
  'portal.ret.sign.signed': 'تم التوقيع عبر الهوية الرقمية. يظهر التوقيع في الإيصال ضمن بطاقة الزائر.',
  'portal.ret.sign.cancelled': 'رفضت التوقيع في الهوية الرقمية. لم يتغير شيء: يبقى توقيعك بالاسم المكتوب مسجّلًا.',
  'portal.ret.sign.failed': 'لم يكتمل التوقيع عبر الهوية الرقمية. يبقى توقيعك بالاسم المكتوب مسجّلًا، ويمكنك المحاولة من بطاقة الزائر.',
  'portal.ret.sign.unknown': 'لم تُجب الهوية الرقمية في الوقت المحدد، لذلك لا يظهر السجل موقّعًا. يمكنك المحاولة من بطاقة الزائر.',

  'portal.kiosk.badge.printing': 'جارٍ طباعة بطاقتك…',
  'portal.kiosk.badge.printed': 'طُبعت بطاقتك. يُرجى أخذها من الطابعة.',
  'portal.kiosk.badge.failed': 'لم تُطبع بطاقتك. تم تسجيل وصولك. يمكنك المحاولة مرة أخرى أو استلام بطاقتك من الاستقبال.',
  'portal.kiosk.badge.unknown': 'تعذّر التأكد من طباعة بطاقتك. تم تسجيل وصولك. يُرجى النظر إلى الطابعة أو السؤال في الاستقبال؛ وقد أُبلغ الاستقبال.',
  'portal.kiosk.badge.unavailable': 'تم تسجيل وصولك. يُرجى استلام بطاقتك من الاستقبال.',
  'portal.kiosk.badge.retry': 'المحاولة مرة أخرى',
  'portal.kiosk.badge.limit': 'يُرجى استلام بطاقتك من الاستقبال.',

  'portal.kiosks.badgePrint': 'طباعة البطاقة على طابعة هذا الكشك',
  'portal.kiosks.printer': 'طابعة بطاقات الكشك',
  'portal.kiosks.printerHint': 'الطابعات الطرفية المسموح بها في هذا الموقع (التكاملات ← الأجهزة). إذا تعذّر الوصول إلى الطابعة، يُوجَّه الزوار إلى الاستقبال ويُبلَّغ الاستقبال.',
  'portal.kiosks.printerNone': 'لا توجد طابعة مسموح بها في هذا الموقع بعد. اسمح بواحدة أولًا من التكاملات ← الأجهزة.',
  'portal.kiosks.printerChoose': 'اختر طابعة',

  'portal.printer.label': '{agent} · {printer}',
  'portal.printer.simulator': 'محاكي',
  'portal.printer.offline': 'الوكيل غير نشط',
  'portal.printer.kiosk': 'مستخدمة في كشك',

  'portal.desk.printer': 'الطباعة على',
  'portal.desk.browser': 'هذا الحاسوب (طباعة المتصفح)',
  'portal.desk.device': 'طابعة المكتب: {name}',
  'portal.desk.status': 'مهمة طابعة المكتب',
  'portal.desk.status.queued': 'في قائمة الانتظار',
  'portal.desk.status.sent': 'أُرسلت إلى الطابعة، بانتظار ردها',
  'portal.desk.status.printed': 'طُبعت',
  'portal.desk.status.failed': 'فشلت: لم يُطبع شيء. اطبع مرة أخرى مع ذكر السبب، أو استخدم طباعة المتصفح.',
  'portal.desk.status.unknown': 'غير معروفة: لم تؤكد الطابعة. افحص الطابعة قبل الطباعة مرة أخرى؛ وقد فُتحت مهمة للاستقبال.',
  'portal.desk.status.cancelled': 'أُلغيت',
  'portal.desk.preview': 'أُرسلت البطاقة إلى طابعة المكتب',
  'portal.desk.noCredential': 'طباعة البطاقة لا تُصدر بيانات اعتماد دخول ولا تغيّرها أبدًا.',
};
